import { Login } from "./components/AuthCompnents/Login";
import { CalendarioContainer } from "./components/EmpresaComponents/CalendarioContainer";
import { CreateEmpresaForm } from "./components/EmpresaComponents/CreateForm/CreateEmpresaForm";
import { EmpresaDetails } from "./components/EmpresaComponents/EmpresaDetails";
import { EmpresasList } from "./components/EmpresaComponents/EmpresasList";
import { Home } from "./components/Home";
import { PanelContainer } from "./components/PanelComponents/PanelContainer";
import { EditPipeline } from "./components/PipelineComponents/EditComponents/EditPipeline";
import { PipelineLayout } from "./components/PipelineComponents/PipelineLayout";
import { TareasLayout } from "./components/TareasComponents/TareasLayout";
import { TaskDetail } from "./components/TareasComponents/TaskDetail";
import { TaskDetailContainer } from "./components/TareasComponents/TaskDetailContainer";
import { CambiarPassword } from "./components/UserComponents/CambiarPassword";
import { PerfilContainer } from "./components/UserComponents/PerfilContainer";
import { VendManagementContainer } from "./components/VendManagementComponents/VendManagementContainer";
import { AdminPanelUIProvider } from "./context/AdminPanelUIContext";

type Route = {
    path: string;
    element: React.ReactNode;
}

type AppRoute = {
    nameSection: string;
    home: Route;
    nested: Route[];
}

const homeRoutes: AppRoute = {
    nameSection: "Home",
    home: {
        path: "/",
        element: <Home/> 
    },
    nested: []
} 

const perfilRoutes: AppRoute = {
    nameSection: "Usuario",
    home: {
        path: "/perfil",
        element: <PerfilContainer />
    },
    nested: [
        {
            path: "cambiar-password",
            element: <CambiarPassword />
        },
    ],
}

const empresaRoutes: AppRoute = {
    nameSection: "Empresas",
    home: {
        path: "/empresa",
        element: <EmpresasList />
    },
    nested: [
        {
            path: ":id",
            element: <EmpresaDetails />
        },
        {
            path: "nueva",
            element: <CreateEmpresaForm />
        },
    ]
}

const pipelineRoutes: AppRoute = {
    nameSection: "Embudo de empresas",
    home: {
        path: "/pipeline",
        element: <PipelineLayout />
    },
    nested: [
        {
            path: "editar",
            element: <EditPipeline />
        },
    ]
}

const taskCalendarRoutes: AppRoute = {
    nameSection: "Calendario de tareas",
    home: {
        path: "/calendario",
        element: <TareasLayout />
    },
    nested: [
        {
            path: ":id",
            element: <TaskDetailContainer />
        },
    ]
}

const dealCalendarRoutes: AppRoute = {
    nameSection: "Calendario de campañas",
    home: {
        path: "/calendario-empresas",
        element: <CalendarioContainer />
    },
    nested: []
}

const panelRoutes: AppRoute = {
    nameSection: "Panel de administración",
    home: {
        path: "/panel",
        element: (
            <AdminPanelUIProvider>
                <PanelContainer />
            </AdminPanelUIProvider>
        )
    },
    nested: []
}

const vendedoresRoutes: AppRoute = {
    nameSection: "Vendedores",
    home: {
        path: "/vendedores",
        element: <VendManagementContainer />
    },
    nested: []
}

export const ArrayRoutes = [
    homeRoutes,
    empresaRoutes,
    pipelineRoutes,
    taskCalendarRoutes,
    dealCalendarRoutes,
    perfilRoutes,
    panelRoutes,
    vendedoresRoutes,
];

export const AppRoutes2 = {
    homeRoutes: homeRoutes,
    empresa: empresaRoutes,
    pipeline: pipelineRoutes,
    taskCalendar: taskCalendarRoutes,
    dealCalendar: dealCalendarRoutes,
    perfil: perfilRoutes,
    panel: panelRoutes,
    vendedor: vendedoresRoutes,
}

const AppRoutes = [
  {
    path: '/',
    element: <Home/>
  },
  {
    path: '/empresa',
    element: <EmpresasList />
  },
  {
    path: '/empresa/:id',
    element: <EmpresaDetails />
  },
{
    path: "/empresa/nueva",
    element: <CreateEmpresaForm />
},
  {
    path: "/pipeline",
    element: <PipelineLayout />
  },
  {
    path: "/pipeline/editar",
    element: <EditPipeline />
  },
  {
    path: "/calendario",
    element: <TareasLayout />
  },
  {
    path: "/calendario/:id",
    element: <TaskDetailContainer />
  },
  {
    path: "/calendario-empresas",
    element: <CalendarioContainer />
  },
  {
    path: "/perfil",
    element: <PerfilContainer />
  },
  {
    path: "/perfil/cambiar-password",
    element: <CambiarPassword />
  },
    // {
    //     path: "/panel",
    //     element: <PanelContainer />
    // }
];

export default AppRoutes;
